import React, { useState, useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useQuery } from '@tanstack/react-query';
import { getBuildingsByProjectId } from '../../services/api/implementation/impl';
import FormInput from '../../../shared/components/ui/FormInput';
import Button from '../../../shared/components/ui/Button';
import { useParams } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const EditBlock = ({
  onClose,
  onSubmit,
  setIsEditingBlock,
  IsOpenAddNewBlock,
  handleEditBlock,
  onProceed,
  data,
  isSubmitting,
  buildingByProjectId,
  setIsOpenEditProject
}) => {
  const userId = Cookies.get('userId');
  const { id: projectId } = useParams();
  const { register, handleSubmit, setValue } = useForm({
    defaultValues: {
      name: data?.name || '',
      area: data?.area || '',
      building_id: data?.building_id?.toString() || ''
    }
  });

  // Create dropdown options for building permission numbers
  const buildingPermissionOptions = [
    ...(buildingByProjectId?.map((building) => ({
      value: building.id.toString(),
      label: building.permissionNo
    })) || [])
  ];

  // Set default building value when data or buildings are loaded

  // Track page view
  useEffect(() => {
    mixpanel.track('Edit Block Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    if (data?.building_id && buildingByProjectId) {
      setValue('building_id', data.building_id.toString());
    }
  }, [data, buildingByProjectId, setValue]);

  // Function to restrict block area to only numbers and decimals
  const handleBlockAreaChange = useCallback(
    (val) => {
      // Allow numbers and a single decimal point
      const cleanedValue = val
        .replace(/[^0-9.]/g, '')
        .replace(/(\..*?)\..*/g, '$1')
        .slice(0, 8);
      setValue('area', cleanedValue);
    },
    [setValue]
  );

  return (
    <>
      <div>
        <div className="flex flex-col justify-between items-start gap-4">
          <span className="text-lg border-b-[1px] border-stone-200 w-full pb-2">Block details</span>
        </div>
        <div className="flex flex-col gap-4 pt-6">
          <div className="flex justify-between items-center w-full">
            <FormInput
              width={48}
              label={'Block Name'}
              register={register}
              register_key={'name'}
              type={'text'}
              defaultValuePre={data?.name}
            />

            <FormInput
              width={48}
              label={'Block area'}
              register={register}
              register_key={'area'}
              type={'text'}
              defaultValuePre={data?.area}
              onType={handleBlockAreaChange}
            />
          </div>
          <div className="flex gap-2 items-end justify-between w-full">
            <FormInput
              width={91}
              label={'Building'}
              register={register}
              register_key={'building_id'}
              type={'dropdown'}
              options={buildingPermissionOptions}
              defaultValuePre={data?.building_id?.permissionNo?.toString()}
            />
            <Button
              type="button"
              onClick={() => setIsOpenEditProject(true)}
              displayType="secondary"
              className="mb-1 px-3 py-2 text-sm h-10">
              Add
            </Button>
          </div>
        </div>

        <div className="w-full flex justify-end items-center space-x-4 mt-8">
          <Button type="reset" onClick={onClose} displayType="secondary">
            Cancel
          </Button>
          <Button onClick={handleSubmit(onProceed)} type="submit" disabled={isSubmitting}>
            Save
          </Button>
        </div>
      </div>
    </>
  );
};

export default EditBlock;
